import { translations } from '../i18n/config';

export const isIOS = ()  => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
  export const getLanguageNameByLanguageCode = (lang: string) => {
    switch(lang) {
      case 'he':
        return 'עברית'
      case 'en':
        return 'English'
      case 'fr':
        return 'Français'
      case 'id':
        return 'Indonesian'
      case 'pt':
          return 'Português'
      case 'es':
        return 'Español'
      case 'tr':
        return 'Türkçe'
      case 'it':
        return 'Italiano'
      case 'th': 
        return 'ไทย'
      case 'zh':
          return '简体'
      case 'vi':
            return 'Tiếng Việt'
      case 'ru':
              return 'Русский'
              case 'ar':
                return 'العربية'
                case 'ja':
                  return '日本語'
      default: 
        return 'English'
    }
  }
export const getCountryByLanguage = (lang: string) => {
    switch(lang) {
      case 'he':
        return 'IL'
      case 'en':
        return 'GB'
      case 'fr':
        return 'FR'
      case 'id':
        return 'ID'
      case 'pt':
          return 'PT'
      case 'es':
        return 'ES'
      case 'tr':
        return 'TR'
        case 'it':
          return 'IT'
                  case 'th':
          return 'TH'
          case 'zh':
          return 'CN'       
             case 'ru':
          return 'RU'        
            case 'vi':
          return 'VI'
          case 'ja':
          return 'JP'
          case 'ar':
            return 'SA'

      default: 
        return 'GB'
    }
  }
  export const getTranslation = (context: string) => {
    const language = getLanguage()
    localStorage.setItem("lang", language!)
    //@ts-ignore
    const translation = translations[language] ? translations[language] : translations['en'];
    //@ts-ignore
    const t = translation[context]
    return t
  }
  export const supportedLanguages = ['en', 'es','he','pt', 'tr', 'fr', 'id', 'it', 'th', 'zh', 'vi', 'ru', 'ja', 'ar']

  export const getLanguage = () => {
      const pathLanguage = window.location.pathname.split('/')[1];
      const queryLanguage = new URLSearchParams(window.location.search).get('language');
      if (supportedLanguages.includes(pathLanguage)) return pathLanguage;
      if (queryLanguage && supportedLanguages.includes(queryLanguage)) return queryLanguage;
    let language = navigator.language.split("-")[0] || "en"
    if(!supportedLanguages.includes(language)) {
      language = "en"
    }
    const languageSelected = localStorage.getItem("lang") === null ?  language : localStorage.getItem("lang")
    return languageSelected as string
  }
  export function debounce<Params extends any[]>(
    func: (...args: Params) => any,
    timeout: number,
  ): (...args: Params) => void {
    let timer: NodeJS.Timeout
    return (...args: Params) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func(...args)
      }, timeout)
    }
  }
